import { useState } from "react";
import { IconButton, Popover, Typography, Box } from "@mui/material";
// import FunctionsIcon from '@mui/icons-material/Functions';
import CalculateIcon from "@mui/icons-material/Calculate";

const FormulaLayout = ({children,showValue}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;

  return (
    <>
      <div className="d-flex" style={{pointerEvents:'all'}}>
      {showValue?showValue:""}
        <IconButton
          size="small"
          onClick={handleOpen}
          sx={{ padding: "0 0 0 4px" }}
        >
          <CalculateIcon fontSize="inherit" />
        </IconButton>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" style={{ fontFamily: 'Poppins'}}>
           {children}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default FormulaLayout;
